import type { JSX } from 'react';
import { FormSection, Radio } from '@ksyos/design-system';
import type { BariPostNurseSpecialistFollowUpData } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistFollowUp/types';
import { bariPostNurseSpecialistFollowUpExperts } from '@common/customControls/bariatrics';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { BariatricsExternalReferral } from '../../bariatrics/BariatricsExternalReferral';
import {
    BooleanRadioGroupFormGroup,
    RadioGroupFormGroup,
    TextAreaFormGroup,
} from '../../processActivityFormGroupFields';

export function BariPostNurseSpecialistFollowUpBeoordelingEnVervolgEdit(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariPostNurseSpecialistFollowUpData>();

    return (
        <FormSection title="Beoordeling en vervolg">
            <TextAreaFormGroup
                fieldKey="beleid"
                label="Beleid"
            />
            <BooleanRadioGroupFormGroup
                fieldKey="interne_expert_inschakelen"
                isRequired={true}
                label="Interne expert inschakelen"
                onChange={handleChangeInterneExpertInschakelen}
                tooltipText="Een expert inschakelen binnen het Ksyos natraject. Dit is een lifestylecoach, psycholoog of diëtist."
                type="radio"
            />
            {data.interne_expert_inschakelen && (
                <>
                    <RadioGroupFormGroup
                        fieldKey="expert"
                        isRequired={true}
                        label="Expert"
                    >
                        {bariPostNurseSpecialistFollowUpExperts.map((value) => (
                            <Radio
                                key={value}
                                label={value}
                                value={value}
                            />
                        ))}
                    </RadioGroupFormGroup>

                    {data.expert && (
                        <TextAreaFormGroup
                            fieldKey="expert_hulpvraag"
                            isRequired={true}
                            label="Hulpvraag aan expert"
                        />
                    )}
                </>
            )}
            <BooleanRadioGroupFormGroup
                fieldKey={'extern_doorverwijzen'}
                isRequired={true}
                label={'Extern doorverwijzen'}
                onChange={handleChangeExternDoorverwijzen}
                tooltipText="Doorverwijzen naar een expert die niet binnen het Ksyos natraject valt."
                type="radio"
            />
            {data.extern_doorverwijzen && <BariatricsExternalReferral />}
        </FormSection>
    );

    async function handleChangeInterneExpertInschakelen(value: boolean | null): Promise<void> {
        onChange(
            {
                expert: null,
                expert_hulpvraag: null,
                interne_expert_inschakelen: value,
            },
            'interne_expert_inschakelen'
        );
    }

    async function handleChangeExternDoorverwijzen(value: boolean | null): Promise<void> {
        return onChange(
            {
                assets: [],
                datum_verwijzing: null,
                extern_doorverwijzen: value,
                naam_externe_behandelaar: null,
                reden_doorverwijzing: null,
                type_behandelaar: null,
                type_behandelaar_overig: null,
            },
            'extern_doorverwijzen'
        );
    }
}
